import {createAction} from "redux-actions";
import {makeActionType} from "../utils";
import {resetError, setError} from "./errors";
import request from './utils/request';
import {urls} from "../constants/app";

const namespace = 'SUPPLIERB';

export const setSuppliers = createAction(makeActionType(namespace, ['SET']));
export const setCountSuppliers = createAction(makeActionType(namespace, ['SET', 'COUNT']));
export const deleteSupplierbSuccess = createAction(makeActionType(namespace, ['DELETE', 'SUPPLIERB']));
export const addSupplierSuccess = createAction(makeActionType(namespace, ['ADD', 'SUPPLIER']));
export const updateSupplierSuccess = createAction(makeActionType(namespace, ['UPDATE', 'SUPPLIER']));

export function fetchSuppliers(withoutLoader = false, force = false) {
    return async (dispatch, getState) => {
        const { suppliers } = getState();

        if (!force && suppliers.items && suppliers.items.length > 0) {
            return;
        }

        !withoutLoader && dispatch({ type: 'SET_LOADER', field: 'suppliers', value: true });
        dispatch(resetError('suppliers'));
        try {
            const suppliers = await request({ method: 'get', url: urls.suppliers });
            const enrichedSuppliers = suppliers.map(supplier => ({
                ...supplier,
                name: supplier.name,
            }))
            dispatch(setSuppliers(enrichedSuppliers));
            dispatch(setCountSuppliers(enrichedSuppliers.length));
        } catch (error) {
            dispatch(setError(error, 'suppliers'));
        } finally {
            !withoutLoader && dispatch({ type: 'SET_LOADER', field: 'suppliers', value: false });
        }
    }
}

export function deleteSuppliers(id) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'suppliers', value: true });
        try {
            await request({ method: 'delete', url: `${urls.suppliers}/${id}`});
            dispatch(deleteSupplierbSuccess(id));
            dispatch(setCountSuppliers(getState().suppliers.items.length - 1));
        } catch (error) {
            dispatch(setError(error, 'suppliers'));
        } finally {
            dispatch({ type: 'SET_LOADER', field: 'suppliers', value: false });
        }
    }
}

export function addSuppliers(supplierData) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'supplier', value: true });
        try {
            const newSupplier = await request({
                method: 'post',
                url: urls.suppliers,
                data: supplierData
            });
            dispatch(addSupplierSuccess(newSupplier));
            dispatch(setCountSuppliers(getState().suppliers.items.length + 1));
        } catch (error) {
            dispatch(setError(error, 'supplier'));
        } finally {
            dispatch({ type: 'SET_LOADER', field: 'supplier', value: false });
        }
    }
}

export function updateSuppliers(id, supplierData) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'supplier', value: true });
        try {
            const updatedSupplier = await request({
                method: 'put',
                url: `${urls.suppliers}/${id}`,
                data: supplierData
            });
            dispatch(updateSupplierSuccess(updatedSupplier));
        } catch (error) {
            dispatch(setError(error, 'supplier'));
        } finally {
            dispatch({ type: 'SET_LOADER', field: 'supplier', value: false });
        }
    }
}
